{
  "title": "Foresight",
  "source": "Player's Handbook",
  "levelAndSchool": "9th-level divination",
  "level": 9,
  "castingTime": "1 minute",
  "range": "Touch",
  "components": "V, S, M (a hummingbird feather)",
  "duration": "8 hours",
  "description": [
    "You touch a willing creature and bestow a limited ability to see into the immediate future. For the duration, the target can’t be surprised and has advantage on attack rolls, ability checks, and saving throws. Additionally, other creatures have disadvantage on attack rolls against the target for the duration. This spell immediately ends if you cast it again before its duration ends."
  ],
  "spellLists": ["bard", "druid", "warlock", "wizard"]
}
